import * as svg from "../../../assets/question-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const QuestionIcon = iconBuilder(svg, "QuestionIcon", "0 0 12 13");
